"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _propTypes = _interopRequireDefault(require("prop-types")),
    _ReduxFirestoreContext = _interopRequireDefault(require("./ReduxFirestoreContext")),
    _createFirebaseInstance = _interopRequireDefault(require("./createFirebaseInstance"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ReduxFirestoreProvider() {
  var props = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      children = props.children,
      config = props.config,
      dispatch = props.dispatch,
      firebase = props.firebase,
      createFirestoreInstance = props.createFirestoreInstance,
      initializeAuth = props.initializeAuth,
      extendedFirestoreInstance = _react["default"].useMemo(function () {
    var extendedFirebaseInstance = firebase._reactReduxFirebaseExtended ? firebase : (0, _createFirebaseInstance["default"])(firebase, config, dispatch),
        extendedFirestoreInstance = createFirestoreInstance(firebase, config, dispatch);
    return initializeAuth && extendedFirebaseInstance.initializeAuth(), extendedFirestoreInstance;
  }, [firebase, config, dispatch, createFirestoreInstance, initializeAuth]);

  return _react["default"].createElement(_ReduxFirestoreContext["default"].Provider, {
    value: extendedFirestoreInstance
  }, children);
}

ReduxFirestoreProvider.defaultProps = {
  initializeAuth: !0
}, ReduxFirestoreProvider.propTypes = {
  children: _propTypes["default"].node,
  config: _propTypes["default"].object.isRequired,
  dispatch: _propTypes["default"].func.isRequired,
  createFirestoreInstance: _propTypes["default"].func.isRequired,
  initializeAuth: _propTypes["default"].bool,
  firebase: _propTypes["default"].object.isRequired
};
var _default = ReduxFirestoreProvider;
exports["default"] = _default, module.exports = exports["default"];